module.exports = __webpack_public_path__ + "static/media/view5.279547c8.jpg";